/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Plants(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.59878 2.70046C9.88416 2.51912 10.2652 2.54835 10.5187 2.79031C11.4364 3.66638 12.1543 4.73095 12.6242 5.90945C12.9345 6.68807 13.1284 7.50518 13.2082 8.33523C14.7076 7.3103 16.4921 6.75027 18.3341 6.75027C18.5328 6.75044 18.7239 6.8295 18.8644 6.97C19.0048 7.11059 19.0841 7.30159 19.0841 7.50027C19.084 9.90911 18.1263 12.2198 16.423 13.9231C14.7197 15.6263 12.4089 16.5832 10.0002 16.5833C7.59128 16.5832 5.28067 15.6264 3.5773 13.9231C1.87392 12.2197 0.91723 9.9092 0.917144 7.50027L0.931792 7.35281C0.960627 7.20882 1.03153 7.0754 1.13687 6.97C1.2775 6.82946 1.46832 6.75027 1.66714 6.75027C2.85977 6.75031 4.04087 6.98531 5.14273 7.44168C5.72299 7.68205 6.27509 7.98256 6.79117 8.33523C6.87096 7.50508 7.06669 6.68815 7.3771 5.90945C7.84696 4.73094 8.56488 3.66637 9.48257 2.79031L9.59878 2.70046ZM2.45914 8.29226C2.63979 10.0123 3.40371 11.6284 4.63785 12.8626C5.87171 14.0964 7.48765 14.8595 9.20718 15.0403C9.13108 14.3167 8.95251 13.6057 8.673 12.9309C8.29193 12.0111 7.73347 11.175 7.02945 10.471C6.32543 9.76695 5.48929 9.20851 4.56949 8.82742C3.89443 8.5478 3.18308 8.36832 2.45914 8.29226ZM17.5412 8.29226C15.8215 8.47297 14.2058 9.23712 12.9718 10.471C11.7379 11.7049 10.9729 13.3206 10.7921 15.0403C12.5121 14.8597 14.1283 14.0966 15.3625 12.8626C16.5965 11.6285 17.3605 10.0121 17.5412 8.29226ZM10.0002 4.4241C9.48282 5.03126 9.06635 5.72006 8.76968 6.46414C8.37962 7.44256 8.20544 8.49417 8.25796 9.54617C8.25863 9.55957 8.25801 9.57295 8.25796 9.58621C8.98856 10.357 9.57792 11.2498 10.0002 12.2249C10.4189 11.2578 11.0062 10.3638 11.7433 9.58621C11.7433 9.57294 11.7427 9.55957 11.7433 9.54617C11.7958 8.4942 11.6207 7.44253 11.2306 6.46414C10.9339 5.72001 10.5175 5.03129 10.0002 4.4241Z"
        fill="#35424F"
      />
    </svg>
  )
}

Plants.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Plants
